import {
  getTotalEmergencyPayout,
  getTotalRegularPayout,
  withdrawalStatus,
} from "../../services/payout.service";
import { useEffect, useState } from "react";

import Card from "../../components/cards/Card";
import Dashboard from "../dashboard/Dashboard";
import { NavLink } from "react-router-dom";
import showToast from "../../utils/show.toast";

export default function PayoutDashboard() {
  const [isLoadingEmergencyCount, setIsLoadingEmergencyCount] =
    useState<boolean>(false);
  const [emergencyCount, setEmergencyCount] = useState<number>(0);

  const [isLoadingRegularCount, setIsLoadingRegularCount] =
    useState<boolean>(false);
  const [regularCount, setRegularCount] = useState<number>(0);

  useEffect(() => {
    fetchEmergencyCount();
    fetchRegularCount();
  }, []);

  const fetchEmergencyCount = async () => {
    setIsLoadingEmergencyCount(true);

    try {
      const emergencyCountResult = await getTotalEmergencyPayout();
      setEmergencyCount(emergencyCountResult);
    } catch (error) {
      showToast("Error feching Emergency count data", false);
      return;
    } finally {
      setIsLoadingEmergencyCount(false);
    }
  };

  const fetchRegularCount = async () => {
    setIsLoadingRegularCount(true);
    try {
      const regularCountResult = await getTotalRegularPayout();
      setRegularCount(regularCountResult);
    } catch (error) {
      showToast("Error fetching Regular-count data:", false);
    } finally {
      setIsLoadingRegularCount(false);
    }
  };

  return (
    <Dashboard pageTitle="Payouts Dashboard">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
        <NavLink to={`/emergency-payouts`}>
          <Card
            title="Emergency Payouts"
            description="Total number of emergency payout requests."
            color={"red"}
            number={0}
            isLoading={isLoadingEmergencyCount}
          />
        </NavLink>

        <NavLink to={`/regular-payout/list?status=${withdrawalStatus.PENDING}`}>
          <Card
            title="Regular Payouts"
            description="Total number of active withdrawal request."
            number={0}
            isLoading={isLoadingRegularCount}
          />
        </NavLink>

        <NavLink to={`/payout-history/list?status=${withdrawalStatus.PAID}`}>
          <Card
            title="Payout History"
            description="Total number of payouts"
            number={0}
          />
        </NavLink>
      </div>
    </Dashboard>
  );
}
